(function() {
    var chooseProductTmpl = 
    '<div class="prd_select_after">' +
        '<div class="after_img">' +
            '<img src="/lg5-common/images/PRS/mobile/{{category}}.svg" alt="">' +       // BTOCSITE-77411
        '</div>' +
        '<div class="after_cnt">' +
            '<div class="cnt_name">{{product}} {{model}}</div>' +
            '<div class="cnt_price">{{vcui.number.addComma(price)}}원</div>' +
        '</div>' +
        '<a href="#n" class="after_cancel">선택 취소</a>' +
    '</div>';

    var validation;
    var authValidation;
    var authManager;
    var addressFinder;
    var dateUtil = vcui.date;
    var isLogin = $('html').data('login') == 'Y' || $('.contents.support').data('login') == 'Y' ? true : false;
    //isLogin = true; // test
    var btnCheck = true;
    // BTOCSITE-64877 가전 세척 Page PC 접속 시 예약 버튼 위치 화면 고정 개발 요청
    var productInfoCheck = "N";
    var productInfo = $('.contents.support').data('info');
    var productName = $('.contents.support').data('name');

    var reservation = {
        init: function() {
            var self = this;
            
            self.$cont = $('.contents.support');
            self.$submitForm = self.$cont.find('#submitForm');

            self.$stepProduct = self.$cont.find('#stepProduct');
            self.$installTypeBox = self.$cont.find('#installTypeBox');
            self.$stepInput = self.$cont.find('#stepInput');
            self.$stepDate = self.$cont.find('#stepDate');
            self.$stepEngineer = self.$cont.find('#stepEngineer');

            self.$choosePrdBox = self.$stepProduct.find('button.prd_select_before').parent();
            
            self.$dateWrap = self.$stepDate.find('.date-wrap');
            self.$timeWrap = self.$stepDate.find('.time-wrap');

            self.$completeBtns = self.$stepEngineer.find('.btn-group');

            // 팝업
            self.$productPopup = $('.popup-wrap.bestcare');
            self.$authPopup = $('#certificationPopup');
            self.$rentalAlert = $('.popup-wrap.rentinfo');

            self.autoFlag = false; // 희망일시 선택 가능 상태일 때 true
            self.price = null; // 가격
            self.resetFocusFlg = false; // BTOCSITE-77411: when the focus was reset, flg = true

            var register = $.extend({}, self.getValidationReg(), self.getAuthValidationReg());
            var authRegister = self.getAuthValidationReg();
            
            // 고객지원 - 출장 서비스 예약 에서 접근 했을 때 안내 메세지
            var supportRegex = /\/service-engineer-reservation$/i;
            // 보유제품 - 세척 서비스 신청에서 접근 했을 때 안내 메세지
            var productUrl = "/manage-products-detail";

            if (supportRegex.test(document.referrer) || document.referrer.indexOf(productUrl) > -1) {
                setTimeout(function(){
                    $('.toast-message').vcToast('show', '세척 받으실 제품을 다시 한번 선택해 주세요.');
                    },300);
            }

            // 고객지원 - 출장 서비스 예약 에서 접근 했을 때 렌탈 이용 안함 체크
            if (supportRegex.test(document.referrer)){
                $('#rentalN').prop('checked', true);
            }            

            vcui.require(['ui/validation'], function () {
                validation = new vcui.ui.CsValidation('.contents.support > .cont-wrap.bestcare', {register: register});
                addressFinder = new AddressFind();

                 //console.log('!!!!! isLogin', isLogin)

                if (!isLogin) {
                    // 비회원 인증
                    authManager = new AuthManager({
                        elem: {
                            form: '#submitForm',
                            name: '#authName',
                            phone: '#authPhoneNo',
                            number: '#authNo'
                        },
                        register: authRegister
                    });

                    authValidation = authManager.getValidation();
                    authValidation.on('validerror', function (e, validItem) {
                        // 인증번호 미입력 시 팝업
                        if (validItem.hasOwnProperty('authNo')) {
                            var $authNo = self.$stepInput.find('#authNo');
                            lgkorUI.alert(
                                '<h1 class="tit">' + validItem.authNo + '</h1>',
                                {ok: function () {
                                    //
                                }},
                                $authNo
                            );
                        }
                    })
                }

                self.setLayout();
                self.bindEvent();
                self.daumPostCode();

                self.$dateWrap.calendar({inputTarget:'#date'});
                self.$timeWrap.timeCalendar({inputTarget:'#time'});

                //self.test();
            });

            // BTOCSITE-64877 가전 세척 Page PC 접속 시 예약 버튼 위치 화면 고정 개발 요청
            if (productInfo &&  productInfo.split(',').length > 1 && productName){
                productInfoCheck = "Y";
                var dataArr = productInfo.split(',');
                var price         = dataArr[3];
                var discountPrice = dataArr[4];
                var periodPrice   = dataArr[5];
                // 할인가와 특정 기간 노출가 체크
                if(discountPrice != null && discountPrice != undefined && discountPrice != "" && discountPrice != "0") {
                    price = discountPrice;
                } else if(periodPrice != null && periodPrice != undefined && periodPrice != "" && periodPrice != "0") {
                    price = periodPrice;
                }

                var sessionProductInfo = sessionStorage.getItem("cleanReserveInfo");
                self.selectProduct({
                    price: price,
                    model: sessionProductInfo.split(',')[2],
                    product: productName,
                    category: sessionProductInfo.split(',')[1],
                    value: dataArr[0]+","+dataArr[1]+","+dataArr[2]
                });
            }
        },

        /* test: function () {
            var self = this;

            // 테스트용 입력

            if (!isLogin) {
                $('#authName').val('홍길동');
                $('#authPhoneNo').val('01045800123');
            } else {
                $('#userNm').val('홍길동');
                $('#phoneNo').val('01045800123');
            }

            $('#privcyCheck').prop('checked', true);
            $('#rentalY').prop('checked', true);
            $('#zipCode').val('06120');
            $('#userAddress').val('서울 강남구 강남대로 480 (논현동)');
            $('#detailAddress').val('123빌딩');

            self.selectProduct({
                price: 80000,
                model: '에어컨',
                product: '벽걸이',
                category: 'CT50020011',
                value: 'xxx'
            });
        }, */
        
        /**
         * 폼 초기화 함수
         * @param {boolean} isUnProduct 제품선택을 제거하였는지 유무 (일부 input 정보 유지)
         */
        reset: function (isUnProduct) {
            var self = this;

            //console.log('!!!!!', 'reset', isUnProduct);

            if (isUnProduct !== true) {
                self.$cont.find('.ui_all_checkbox').vcCheckboxAllChecker('setAllNoneChecked');
                self.$stepProduct.find('input[type=radio]').prop('checked', false);
                self.$stepProduct.find('input[type=text], input[type=number], textarea').not(notInput).val('');
                self.$stepProduct.find('.ui_textcontrol').trigger('textcounter:change', { textLength: 0 });                
                self.$installTypeBox.hide();
                
                // 제품 선택 제거
                self.removeProduct();

                if (isLogin) { 
                    // 회원이면 이름, 휴대폰 번호 초기화 제외
                    var notInput = '#userNm, #phoneNo';
                } else {
                    // 비회원용 핸드폰 인증 초기화
                    self.toggleAuthComfirm(false);
                }

                // 예약자 정보 초기화
                self.$stepInput.find('input[type=text], input[type=number], textarea').not(notInput).val('');
            }

            // 희망 일시 이하 폼 초기화
            self.unDate();

            validation.reset();
        },

        /**
         * 희망 일시 이하 폼 초기화 함수
         */
        unDate: function () {
            var self = this;

            self.$stepInput.find('.step-btn-wrap').show(); // 희망 일시 선택 버튼
            self.$stepDate.hide();
            self.$dateWrap.calendar('reset');
            self.$timeWrap.timeCalendar('reset');  

            self.$stepEngineer.hide();

            self.autoFlag = false;

            self.$completeBtns.hide(); // 신청 완료 버튼
        },

        /**
         * 비회원 인증 폼 validation 규칙 반환 함수
        * @returns 
         */
        getAuthValidationReg: function () {
            return {
                authName: {
                    pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
                    msgTarget: '.err-block',
                },
                authPhoneNo: {
                    msgTarget: '.err-block',
                    validate: function(value){
                        return validatePhone(value);
                    } 
                },
                authNo:{
                    /* msgTarget: '.err-block', */
                }
            }
        },

        /**
         * 폼 validation 규칙 반환 함수
         * @returns 
         */
        getValidationReg: function () {
            return {
                privcyCheck: {
                    msgTarget: '.err-block'
                },
                rental: {
                    msgTarget: '.err-block'
                },
                productName: {
                    msgTarget: '.err-block'
                },
                installType: {
                    msgTarget: '.err-block'
                },
                userNm: {
                    pattern: /^[가-힣\s]+$|^[a-zA-Z\s]+$/,
                    msgTarget: '.err-block'
                },
                phoneNo: {
                    msgTarget: '.err-block',
                    validate: function(value){
                        return validatePhone(value);
                    } 
                },
                zipCode: {
                    msgTarget: '.address-err-msg'
                },
                userAddress: {
                    msgTarget: '.address-err-msg'
                },
                detailAddress: {
                    msgTarget: '.address-err-msg'
                },
                date: {
                    msgTarget: '.err-msg'
                },
                time: {
                    msgTarget: '.err-msg'
                }
                
            }
        },

        /**
         * 폼 validation 체크 결과 반환 함수
         * @returns 
         */
        checkValidation: function () {
            var self = this;
            
            var checkListArr = ['privcyCheck', 'rental', 'productName', 'installType', 'userNm', 'phoneNo', 'authName', 'authPhoneNo', 'authNo', 'zipCode', 'userAddress', 'detailAddress']
            var result = validation.validate(checkListArr);

            if (!isLogin) {
                // 비회원 인증 validation 결과값
                return result.success && self.checkAuthUIState();
            } else {
                // 회원
                return result.success;
            }
        },

        /**
         * 비회원 인증 폼 validation 체크 결과 반환 함수
         * @returns 
         */
        checkAuthValidation: function () {
            var checkListArr = ['authName', 'authPhoneNo', 'authNo'];
            var result = authValidation.validate(checkListArr);
            
            return result.success;
        },

        /**
         * 비회원 인증 ui 상태 체크 (validation.js 의 .validate() 에서 숨겨진 element 체크 안하므로 필요)
         * @returns 
         */
        checkAuthUIState: function () {
            var self = this;

            var $authSendBtn = self.$stepInput.find('.btn-send');
            var $authNo = self.$stepInput.find('#authNo');
            var isConfirmAuth = $authSendBtn.prop('disabled') && $authNo.is(':hidden');
            var isSmsAuth = isConfirmAuth || (!$authSendBtn.prop('disabled') && $authNo.is(':visible'));

            //console.log('문자 발송 유무 :', isSmsAuth);
            //console.log('인증 유무 :', isConfirmAuth);

            if (!isSmsAuth) {
                lgkorUI.alert("", {title: '인증 번호 발송 버튼을 선택해주세요.'}, $authSendBtn);
            } else if (!isConfirmAuth) {
                $authNo.val('').data('oldValue', '').focus(); // support-common.js 에 oldValue 관련 keyup, blur 이벤트 있어 이전 입력값 value 살아나. '' 초기화시 같이 제거해야함
            }

            return isSmsAuth && isConfirmAuth;
        },

        /**
         * 달력 ajax 호출 함수
         */
        requestDate: function() {
            var self = this;
            var url = self.$stepInput.data('ajax'),
                param = validation.getAllValues(),
                success = self.checkValidation();

            var productCode = self.$cont.find('#productCode').val();
            var productId = self.$cont.find('#productId').val();

            $.extend(param, {
                serviceType: self.$cont.find('#serviceType').val(),
                productCode: productCode,
                productId: productId,
                category: self.$cont.find('#category').val(),
                subCategory: self.$cont.find('#subCategory').val(),
                lockId: $('#lockId').val()
            });

            self.$timeWrap.timeCalendar('reset');
            
            if (success) {
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataAddTimeout(url, 30000, param, function(result) {
                    var data = result.data,
                        dateArr = data.dateList instanceof Array ? data.dateList : [],
                        fastDate;

                    if (data.resultFlag == 'Y') {
                        if (dateArr.length) {
                            self.dateParam = result.param;

                            fastDate = dateUtil.format(data.fastDate + '' + data.fastTime + '00', 'yyyy.MM.dd hh 시');
                            self.$stepDate.find('.calendar-info .date').html(fastDate);    
                            
                            self.$dateWrap.calendar('update', data.dateList);
                            
                            self.$stepInput.find('.step-btn-wrap').hide();
                            self.$stepDate.show();
                            self.$stepEngineer.hide();
                            self.$completeBtns.hide();

                            $("#deptCode").val(data.deptCode);
                        }
                    } else {
                        if (data.resultMessage) {
                            if (data.tAlert == 'Y') {
                                self.unDate();
                            }

                            lgkorUI.alert("", {
                                title: data.resultMessage
                            });
                        }
                    }
                    lgkorUI.hideLoading();
                }, 'POST');
            }
        },
        
        /**
         * 시간 ajax 호출 함수
         */
        requestTime: function() {
            var self = this,
                url = self.$stepDate.data('timeUrl'),
                param = validation.getAllValues(),
                success = self.checkValidation();

            var productCode = $('#productCode').val();
            var productId = $('#productId').val();

            $.extend(param, {
                serviceType: $('#serviceType').val(),
                productCode: productCode,
                productId: productId,
                category: $('#category').val(),
                subCategory: $('#subCategory').val(),
                date: $('#date').val(),
                deptCode: $('#deptCode').val(),
                lockId: $('#lockId').val()
            });
            param['zipId'] = self.dateParam.zipId;
            param['custNo'] = self.dateParam.custNo;

            if (success) {
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(url, param, function(result) {
                    var data = result.data;

                    if (data.resultFlag == 'Y') {
                        self.$timeWrap.timeCalendar('update', data.timeList);
                        self.$timeWrap.find('.box-desc').hide();
                        self.$timeWrap.find('.box-table').show();

                        self.$stepEngineer.removeClass('active');
                        self.$completeBtns.hide();

                        if ($(window).data('breakpoint').isMobile) {
                            lgkorUI.scrollTo(self.$timeWrap.parent(), $('.prod-selected-wrap').outerHeight());
                        }
                    } else {
                        if (data.resultMessage) {
                            if (data.tAlert == 'Y') {
                                self.unDate();
                            }
                            
                            lgkorUI.alert("", {
                                title: data.resultMessage
                            }); 
                        }
                    }

                    lgkorUI.hideLoading();
                });
            }
        },

        /**
         * 엔지니어 ajax 조회 함수
         */
        requestEngineer: function() {
            var self = this,
                url = self.$stepEngineer.data('ajax'),
                success = self.checkValidation();
            
            var productCode = $('#productCode').val();
            var productId = $('#productId').val();

            var param = {
                serviceType: $('#serviceType').val(),
                category: $('#category').val(),
                subCategory: $('#subCategory').val(),
                zipCode: $('#zipCode').val(),
                userAddress: $('#userAddress').val(),
                detailAddress: $('#detailAddress').val(),
                productCode: productCode,
                productId: productId,
                date: $('#date').val(),
                time: $('#time').val(),
                lockUserId: $('#lockUserId').val(),
                deptCode: $('#deptCode').val(),
                lockId: $('#lockId').val()
            }

            $.extend(param, self.dateParam);

            if (success) {
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataPost(url, param, function(result) {
                    var data = result.data;

                    if (data.resultFlag == 'Y') {

                        self.$stepEngineer.find('.cnt_date').html(vcui.date.format($('#date').val() + '' + $('#time').val() + '00', "yyyy년 MM월 dd일 hh시"));
                        if (self.price) self.$stepEngineer.find('.appcheck_cnt li:eq(1) em').text(vcui.number.addComma(self.price));

                        $("#lockId").val(data.lockId);

                        self.dateParam['resrvSeq'] = data.resrvSeq;

                        self.$stepEngineer.show();
                        self.$completeBtns.show();

                        lgkorUI.scrollTo(self.$stepEngineer, $('.prod-selected-wrap').outerHeight());
                    }

                    lgkorUI.hideLoading();
                });
            }
        },
        
        /**
         * 예약하기 함수
         */
        requestComplete: function() {
            var self = this,
                success = self.checkValidation();

            var url = self.$submitForm.data('ajax');
            var formData = validation.getAllValues();

            $.extend(formData, self.dateParam);

            if (success) {
                lgkorUI.showLoading();
                lgkorUI.requestAjaxDataAddTimeout(url, 30000, formData, function(result) {
                    var data = result.data;

                    if (data.resultFlag == 'Y') {
                        $('#acptNo').val(data.acptNo);
                        $('#engineerNm').val(data.engineerNm);
                        $("#ascYn").val(data.ascYn);
                        self.$submitForm.submit();
                    }
                }, 'POST');
            }
        },

        setLayout: function() {
            var self = this;

            // 선택제품 마크업 제거
            if(productInfoCheck !== "Y") {
                self.$stepProduct.find('.prd_select_after').remove();
            }

            // 회원 유무 따른 form 토글
            self.$stepInput.find('.member').toggle(isLogin);
            self.$stepInput.find('.nomember').toggle(!isLogin);

            // 인증번호 입력 form 숨김
            self.toggleSmsNumber(false);

            // 희망일시 영역 숨김
            self.$stepDate.hide();

            // 엔지니어 영역 숨김
            self.$stepEngineer.hide();
        },

        bindEvent: function() {
            var self = this;

            $('[data-href="#ratesWarrantyGuidePopup"]').on('click', function() {
                lgkorUI.setAcecounter('www.lge.co.kr/acecount/engineerInfoClick.do', '/acecount/engineerInfoClickm.do');
            });

            // reset
            self.$cont.on('reset', self.reset.bind(this));

            // 렌탈 이용중
            self.$cont.find('[name=rental]').on('change', function() {
                switch ($(this).val()) {
                    case 'Y':
                        self.$rentalAlert.vcModal();
                        break;
                    case 'N':
                        
                        break;
                }
            });

            // 인증 번호 발송
            self.$stepInput.on('click', '.btn-send', function() {
                authManager.send(this, function () {
                    self.$stepInput.find('.btn-send').text('재발송');
                    self.toggleSmsNumber(true);
                });
            });

            // 인증 하기 버튼
            self.$stepInput.on('click', '.btn-auth', function(e) {
                if (self.checkAuthValidation()) {
                    authManager.confirm(e.currentTarget, function(success, result) {
                        if (success) {
                            self.toggleAuthComfirm(true);
                            self.toggleSmsNumber(false);
                        }
                    });
                }
            });

            // 주소 찾기
            // self.$stepInput.on('click', '.btn-address', function() { 
            //     addressFinder.open(function(data) { 
            //         var address = data.userSelectedType == 'R' ? data.roadAddress : data.jibunAddress;

            //         self.$stepInput.find('#zipCode').val(data.zonecode);
            //         self.$stepInput.find('#userAddress').val(address);
            //         self.$stepInput.find('#detailAddress').val('').prop('readonly', false);

            //         if (self.autoFlag) {
            //             self.$stepInput.find('.step-btn-wrap').show();
            //             self.$stepDate.hide();
            //             self.$stepEngineer.hide();
            //             self.$completeBtns.hide();
            //             self.$dateWrap.calendar('reset');
            //             self.$timeWrap.timeCalendar('reset');  
            //             self.autoFlag = false;
            //         }
            //     }); 
            // });

            // 희망 일자 선택하기 버튼
            self.$stepInput.on('click', '.step-btn-wrap .btn', function() {
                self.autoFlag = true;
                self.requestDate();
            });

            // 날짜 선택
            self.$dateWrap.on('dateselected', function() {
                self.requestTime();
            });

            // 시간 선택
            self.$timeWrap.on('timeselected', function() {
                self.requestEngineer();
            });

            // 신청 취소
            self.$completeBtns.on('click', '.btn-cancel', function() {
                self.reset();
                //history.back();
            })

            // 신청 하기
            self.$completeBtns.on('click', '.btn-confirm', function() {
                self.setDeliveryMsgYn();
                self.requestComplete();
            });

            // BTOCSITE-77411 START
            $('input[type="radio"].bcs-rdo').on('click', function() {
                $('input[type="radio"].bcs-rdo').not(this).prop('checked', false);
            });

            $(document).on('keyup', function(e) {
                if (e.keyCode == 9 && self.resetFocusFlg) {
                    $('#rentalY').css('outline', '');
                    $('.prd_select_after .cnt_name').removeAttr('tabindex');
                    self.resetFocusFlg = false;
                }
            });
            // BTOCSITE-77411 END

            // BTOCSITE-91052 START
            $("#detailAddress").on('keyup', function () {
                var val =$(this).val();
                if (val && /%/.test(val)) {
                    val = val.replace(/%/g, "");
                    $(this).val(val);
                }
            });
            // BTOCSITE-91052 END

            // 제품 선택 팝업 확인 버튼 클릭 시
            self.$productPopup.on('modalok', function (e, data) {
            	var check = self.getCheck();
            	if(check) {
            		var $chooseINPUT = $(data.el).find('input:checked');
                    
                    if (!!$chooseINPUT.length) {
                        var $li = $chooseINPUT.closest('li');
                        var $head = $li.closest('.accord-cont').prev('.head')
                        
                        // BTOCSITE-33300 : 베스트케어 노출가격 할인가
                        var price = parseInt($li.find('.sale-price').text().replace(/[^\d]/g, ''));
                        var product = $li.find('.bcsrdo_name').text();
                        
                        var model = $head.find('.prd_name').text();
                        var src = $head.find('.prd_img > img').attr('src') || '';
                        var category = src.match(/\w+(?=\.svg)/i) || [];

                        self.selectProduct({
                            price: price,
                            model: model,
                            product: product,
                            category: category.join(''),
                            value: $chooseINPUT.val()
                        });
                        // BTOCSITE-77411 START
                        self.resetFocusFlg = true;
                        $('.prd_select_after .cnt_name').css('outline', 'none');
                        setTimeout(function() {
                            $('.prd_select_after .cnt_name').attr('tabindex', '0').trigger("focus");  
                        }, 300);
                        // BTOCSITE-77411 END
                    } else {
                        e.preventDefault();
                        lgkorUI.alert("", {title: '제품을 선택해 주세요.'});                    
                    } 
            	}
            });

            // 렌탈 안내 팝업
            self.$rentalAlert.on('modalhide', function (e, data) {
                self.$stepProduct.find('#rentalY').prop('checked', false)
                // BTOCSITE-77411 START
                self.resetFocusFlg = true;
                $('#rentalY').css('outline', 'none');
                
                setTimeout(function() {
                    $('#rentalY').trigger("focus");
                }, 300);
                // BTOCSITE-77411 END
            });
        },
        
        getCheck: function () {
        	if(btnCheck) {
        		btnCheck = false;
        		return true;
        	} else {
        		return false;
        	}
        },  

        /**
         * 제품 선택 함수
         * @param {*} data 
         */
        selectProduct: function (data) {
            console.log(" >>> selectProduct in ! ");
            var self = this;

            self.$choosePrdBox.hide().after('<div class="prd_select_after_wrap"></div>'); // BTOCSITE-25077
            var $chooseProductDIV = self.$choosePrdBox.next('div');

            $chooseProductDIV.html(vcui.template(chooseProductTmpl, data));
            var value = data.value;
            if (value && value.split(',').length > 1){
                var valueArr = value.split(',');

                $('#productName').val(valueArr[0]);
                $('#productCode').val(valueArr[0]);
                $('#productId').val(valueArr[1]);
                $('#smartCategoryId').val(valueArr[2]);
            }

            self.price = data.price;

            // // 일반형, 미니워시, 꼬망스, 드럼, 트윈워시 선택 시
            if ($('#productId').val() == "BP90000010" || $('#productId').val() == "BP90000009" || $('#productId').val() == "BP90000008") {
                self.$installTypeBox.show();
            } else {
                self.$installTypeBox.hide();
            }            

            // 삭제 버튼
            $chooseProductDIV.one('click', '.after_cancel', function (e) {
                e.preventDefault();

                self.removeProduct();
                self.reset(true);
            });
        },

        /**
         * 제품 선택 제거 함수
         */
        removeProduct: function () {
            var self = this;

            self.$choosePrdBox.show();
            self.$choosePrdBox.next('div').remove();
            $('#productName').val('');
            $('#productCode').val('');
            $('#productId').val('');
            $('#smartCategoryId').val('');
            $('input[type=radio][name=installType]').prop('checked', false);
            self.$installTypeBox.hide();

            self.price = null;

            self.$productPopup.find('input:checked').prop('checked', false);
            self.$productPopup.find('.ui_accordion[ui-modules="Accordion"]').vcAccordion('collapseAll');
            
            btnCheck = true;
        },

        /**
         * 인증번호 입력 영역 활성화 토글
         * @param {boolean} value 유무
         */
        toggleSmsNumber: function (value) {
            var self = this;
            
            self.$stepInput.find('#authNo').toggle(value).val('').data('oldValue', '').prop('disabled', !value)
            self.$stepInput.find('.authphone_info').toggle(value);
            self.$stepInput.find('.btn-auth').toggle(value);
        },

        /**
         * 인증완료 상태 토글
         * @param {boolean} value 유무
         */
        toggleAuthComfirm: function (value) {
            var self = this;

            var $authName = self.$stepInput.find('#authName');
            var $authPhoneNo = self.$stepInput.find('#authPhoneNo');

            self.$stepInput.find('#userNm').val($authName.val());
            self.$stepInput.find('#phoneNo').val($authPhoneNo.val());

            // 인증 완료 후 변경시 재인증 가능
            if (value) {
                $authName.add($authPhoneNo).on('input.service-wash', function (e) {
                    self.toggleAuthComfirm(false);
                    self.unDate();
                });
            } else {
                $authName.add($authPhoneNo).off('input.service-wash');
            }

            self.$stepInput.find('.btn-send').text(value ? '인증완료' : '인증번호 발송').prop('disabled', value);
        },

        /**
         * Daum 주소 찾기
         */
        daumPostCode: function () {
            var self = this;

            $('#daumPostcode').click(function(){
                setTimeout(function(){
                    execDaumPostcode();
                },100)
            })
                
            // 우편번호 찾기 화면을 넣을 element
            var element_layer = document.getElementById('postLayer');
        
            function execDaumPostcode() {
                new daum.Postcode({
                    oncomplete: function(data) {
        
                        // 각 주소의 노출 규칙에 따라 주소를 조합한다.
                        // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
                        var address = ''; // 주소 변수                        
        
                        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
                        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
                            address = data.roadAddress;
                        } else { // 사용자가 지번 주소를 선택했을 경우(J)
                            address = data.jibunAddress;
                        }
        
                        self.$stepInput.find('#zipCode').val(data.zonecode);
                        self.$stepInput.find('#userAddress').val(address);
                        self.$stepInput.find('#detailAddress').val('').prop('readonly', false);
    
                        if (self.autoFlag) {
                            self.$stepInput.find('.step-btn-wrap').show();
                            self.$stepDate.hide();
                            self.$stepEngineer.hide();
                            self.$completeBtns.hide();
                            self.$dateWrap.calendar('reset');
                            self.$timeWrap.timeCalendar('reset');  
                            self.autoFlag = false;
                        }        
        
                        // iframe을 넣은 element를 안보이게 한다.
                        element_layer.style.display = 'none';
                        $('.ui_modal_close').trigger('click');
                    },
                    width : '100%',
                    height : '100%',
                    maxSuggestItems : 5
                }).embed(element_layer);
        
                // iframe을 넣은 element를 보이게 한다.
                element_layer.style.display = 'block';
        
                // iframe을 넣은 element의 위치를 화면의 가운데로 이동시킨다.
                initLayerPosition();
            }
        
            // 브라우저의 크기 변경에 따라 레이어를 가운데로 이동시키고자 하실때에는
            // resize이벤트나, orientationchange이벤트를 이용하여 값이 변경될때마다 아래 함수를 실행 시켜 주시거나,
            // 직접 element_layer의 top,left값을 수정해 주시면 됩니다.
            function initLayerPosition(){
                var width = 100; //우편번호서비스가 들어갈 element의 width
                var height = 500; //우편번호서비스가 들어갈 element의 height
                var borderWidth = 5; //border의 두께
        
                // 위에서 선언한 값들을 실제 element에 넣는다.
                element_layer.style.width = width + '%';
                element_layer.style.height = height + 'px';
                // 실행되는 순간의 화면 너비와 높이 값을 가져와서 중앙에 뜰 수 있도록 위치를 계산한다.
                element_layer.style.left = 0 + 'px';
                element_layer.style.top = (((window.innerHeight || document.documentElement.clientHeight) - height)/2 - borderWidth) + 'px';
            }            
        },
        /**
         *  전달메세지 전송여부
         */
        setDeliveryMsgYn : function () {
            // 설치 타입이 직렬설치 또는 워시타워일경우 전달메시지 'Y' 처리
            if ( $("input[name=installType]:checked").val() === '직렬설치' || $('#productId').val() == "BP90000007" 
                || $('#productId').val() == "BP90000006" || $('#productId').val() == "BP90000005") {
                $("#deliveryMsgYn").val("Y");
            }
        }
    }

     $(window).ready(function() {
        reservation.init();
    });
})();

//self.$stepInput.find('.btn-send')